import DatePicker, { type DatePickerFieldProps } from '../../../components/fields/DatePickerField';
import CalendarIcon from '../../../icons/mobility/calendar.svg';
import { DateContainer } from './shared';

const DatePickerField = ({ className, ...props }: DatePickerFieldProps) => (
    <DateContainer>
        <DatePicker {...props} className={[className ?? '', 'porsche'].join(' ')} suffixIcon={<CalendarIcon />} />
    </DateContainer>
);

export default DatePickerField;
